(ns livefeed.system-color-scheme
  (:require
   [reagent.core :as reagent]))

(def system-color-scheme (reagent/atom "light"))

(defn watch-color-scheme! []
  (let [media-query (js/window.matchMedia "(prefers-color-scheme: dark)")
        handler     #(reset! system-color-scheme (if (.-matches %) "dark" "light"))]
    (.addEventListener media-query "change" handler)
    ; Set initial value
    (handler media-query)
    ; Return cleanup function
    #(.removeEventListener media-query "change" handler)))
